<template>
  <div
    class="app-content content bg-custome-height pb-0"
    :class="[
      { 'show-overlay': $store.state.app.shallShowOverlay },
      $route.meta.contentClass,
      checkRoute,
    ]"
  >
    <div class="content-overlay" />
    <!-- <div class="header-navbar-shadow" /> -->
    <div
      class="content-wrapper"
      :class="contentWidth === 'boxed' ? 'container p-0' : null"
    >
      <slot name="breadcrumb">
        <app-breadcrumb />
      </slot>
      <div class="content-body">
        <transition
          :name="routerTransition"
          mode="out-in"
        >
          <slot />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import useAppConfig from '@core/app-config/useAppConfig'
import { eventBus } from '@/main'
// import { mounted } from 'vue2-dropzone';

export default {
  components: {
    AppBreadcrumb,
  },
  setup() {
    const { routerTransition, contentWidth } = useAppConfig()

    return {
      routerTransition,
      contentWidth,
    }
  },
  data() {
    return {
      backgroundColor: null,
    }
  },
  computed: {
    currentURL() {
      return window.location.href
    },
    checkRoute() {
      return this.$route?.name == 'projectTask' || this.$route?.name == 'board' ? this.$store.state.app.boardBackGroundColor : null
    },
  },
  mounted() {
    eventBus.$on('backgroundColorSet', data => {
      if (data) {
        this.$store.state.app.boardBackGroundColor = data
      }
    })
    eventBus.$on('backgroundColor', data => {
      if (data) {
        this.$store.state.app.boardBackGroundColor = null
      }
    })
  },
  destroyed() {
    eventBus.$off()
    this.backgroundColor = null
  },
}
</script>

<style></style>
